module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c001a6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MainContent.vue
// module id = 42
// module chunks = 0